/**
 * NUDIENT: CategoryNav, länkarna behåller den valda modellen, paket E2,
 * M-099 punkt 4. Plan: nudient/PLAN-E1-E2-rubrik-kategorinav.md.
 * Laddas av sections/nudient-category-nav.liquid, bara på kollektionssidor,
 * och av sections/nudient-shop-by-case.liquid på startsidan, paket G7, M-103
 * punkt 2.
 *
 * - Gäller länkarna märkta data-nudient-category-link, menylänkar till
 *   kollektioner. Liquid märker bara länkar till kollektioner med bara
 *   telefonskal eller bara skärmskydd, M-127 punkt 2,
 *   snippets/nudient-model-collection.liquid. Övriga länkar, som luggage,
 *   lämnas orörda.
 * - Med ett eget val läggs modellens filter i adressen, så att kunden står
 *   kvar på samma modell i nästa kollektion. Värdet är modellpostens fält
 *   model, som filtret och produktens attribute.specific_phone_model går
 *   på, M-013 och kommentaren i snippets/nudient-model-data.liquid. Inte
 *   visningsnamnet.
 * - Utan eget val står menyns adress orörd. Standardmodellen sparas aldrig
 *   och läggs inte till, M-007.
 * - Följer model:change, också valet som en modells egen sida sparar med
 *   källan page, M-019.
 * - Menyns egna parametrar i adressen står kvar. Ett filter för modellen
 *   som redan står där byts.
 *
 * Värden som inte är tokens:
 * - filter.p.m.attribute.compatible_models: filtrets parameter, M-013
 *   ändringen punkt 1.
 * - data-nudient-category-link och data-nudient-original-href: märkningen
 *   av länkarna och den sparade adressen ur menyn.
 * - model:change: modellminnets händelse, assets/nudient-model-store.js.
 */

import { findModel, getModel } from '@nudient/model-store';

const PARAM = 'filter.p.m.attribute.compatible_models';

const point = () => {
  const model = findModel(getModel());
  const value = model?.model || '';

  document.querySelectorAll('a[data-nudient-category-link]').forEach((link) => {
    if (!(link instanceof HTMLAnchorElement)) return;
    if (!link.dataset.nudientOriginalHref) link.dataset.nudientOriginalHref = link.getAttribute('href') || '';
    const original = link.dataset.nudientOriginalHref;
    if (!original) return;

    let target = original;
    if (value) {
      const url = new URL(original, window.location.origin);
      url.searchParams.set(PARAM, value);
      target = `${url.pathname}${url.search}${url.hash}`;
    }
    if (link.getAttribute('href') !== target) link.setAttribute('href', target);
  });
};

point();
document.addEventListener('model:change', point);
